import { TierFeatureKey } from '@court-sync/shared';
import { useManagementDashboardFeatureAccess } from './useFeatureAccess';

/**
 * Multi-location feature (Professional+). Uses the **academy’s** effective plan
 * (DB + owner Stripe via public API), not the logged-in user’s personal subscription.
 * Required so delegated `academy_admin` users see locations when the owner is on Professional+.
 */
export function useHasMultiLocation(): boolean {
  const { hasAccess } = useManagementDashboardFeatureAccess(TierFeatureKey.MULTI_LOCATION);
  return hasAccess;
}
